import React from "react";
import { FC } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import Page from "../../components/Page";

const NotFoundView: FC<React.PropsWithChildren<unknown>> = () => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  return (
    <Page title="404: Not found">
      <Container maxWidth="lg">
        <Typography
          align="center"
          variant={mobileDevice ? "h4" : "h1"}
          color="textPrimary"
        >
          404: Page Not Found
        </Typography>
        <Typography align="center" variant="subtitle2" color="textSecondary">
          No route registered for {location.pathname}.
        </Typography>
        <Box mt={6} display="flex" justifyContent="center">
          <Button
            color="primary"
            component={RouterLink}
            to="/"
            variant="contained"
          >
            Back to home
          </Button>
        </Box>
      </Container>
    </Page>
  );
};

export default NotFoundView;
